import { Modal, Row, Space, Typography, Card, Descriptions, Divider, Badge, Tag } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, ApartmentOutlined } from '@ant-design/icons';
import preval from 'preval.macro';
import pac from '../../../package.json';
import { useUserContextHook } from '../../hooks/useUserContextHook';

const dateTimeStamp = preval`module.exports = new Date().toLocaleString();`

export const AboutComponent = ({ isOpen, setAboutModal }) => {
	const { employeeDetail } = useUserContextHook();

	return (
		<Modal
			open={isOpen}
			onCancel={() => setAboutModal(false)}
			onOk={() => setAboutModal(false)}
			title={
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<UserOutlined />
					<span>Employee Profile & System Information</span>
				</div>
			}
			width={800}
			cancelButtonProps={{
				style: {
					display: 'none'
				}
			}}
		>
			{/* Employee Information Card */}
			<Card
				title={
					<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<UserOutlined style={{ color: '#1890ff' }} />
						<span>Personal Information</span>
					</div>
				}
				size="small"
				style={{ marginBottom: 16 }}
			>
				<Descriptions column={2} size="small">
					<Descriptions.Item label="Name">
						<Typography.Text strong>{employeeDetail?.name || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Name (Arabic)">
						<Typography.Text>{employeeDetail?.nameAr || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Username">
						<Typography.Text code>{employeeDetail?.userName || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Employee ID">
						<Tag color="blue">{employeeDetail?.employeeId || 'N/A'}</Tag>
					</Descriptions.Item>
					<Descriptions.Item label="Email">
						<Typography.Text copyable={!!employeeDetail?.email}>
							<MailOutlined style={{ marginRight: 4 }} />
							{employeeDetail?.email || 'N/A'}
						</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Phone">
						<Typography.Text copyable={!!employeeDetail?.phone}>
							<PhoneOutlined style={{ marginRight: 4 }} />
							{employeeDetail?.phone || 'N/A'}
						</Typography.Text>
					</Descriptions.Item>
				</Descriptions>
			</Card>

			{/* Work Information Card */}
			<Card
				title={
					<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<ApartmentOutlined style={{ color: '#52c41a' }} />
						<span>Work Information</span>
					</div>
				}
				size="small"
				style={{ marginBottom: 16 }}
			>
				<Descriptions column={2} size="small">
					<Descriptions.Item label="Position">
						<Typography.Text strong>{employeeDetail?.position || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Division">
						<Typography.Text>{employeeDetail?.division || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Business">
						<Typography.Text>{employeeDetail?.business || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Reporting To">
						<Typography.Text>{employeeDetail?.reportingTo || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Status">
						<Badge
							status={employeeDetail?.status === 'ACTIVE' ? 'success' : 'error'}
							text={employeeDetail?.status || 'N/A'}
						/>
					</Descriptions.Item>
					<Descriptions.Item label="Station">
						<Typography.Text>{employeeDetail?.station || 'N/A'}</Typography.Text>
					</Descriptions.Item>
				</Descriptions>
			</Card>

			{/* Location Information Card */}
			<Card
				title={
					<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<EnvironmentOutlined style={{ color: '#fa8c16' }} />
						<span>Location Information</span>
					</div>
				}
				size="small"
				style={{ marginBottom: 16 }}
			>
				<Descriptions column={2} size="small">
					<Descriptions.Item label="City">
						<Typography.Text>{employeeDetail?.city || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Country">
						<Typography.Text>{employeeDetail?.country || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Region">
						<Typography.Text>{employeeDetail?.region || 'N/A'}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Station City ID">
						<Typography.Text>{employeeDetail?.stationCityId || 'N/A'}</Typography.Text>
					</Descriptions.Item>
				</Descriptions>
			</Card>

			{/* Permissions & Roles Card */}
			<Card
				title="Permissions & Roles"
				size="small"
				style={{ marginBottom: 16 }}
			>
				<Row>
					<Space wrap>
						<Tag color={employeeDetail?.isSalesperson ? 'green' : 'default'}>
							{employeeDetail?.isSalesperson ? 'Salesperson ✓' : 'Not Salesperson'}
						</Tag>
						<Tag color={employeeDetail?.isDriver ? 'blue' : 'default'}>
							{employeeDetail?.isDriver ? 'Driver ✓' : 'Not Driver'}
						</Tag>
						<Tag color={employeeDetail?.allowNoFleet ? 'orange' : 'default'}>
							{employeeDetail?.allowNoFleet ? 'No Fleet Allowed ✓' : 'Fleet Required'}
						</Tag>
						<Tag color={employeeDetail?.allowAdHock ? 'purple' : 'default'}>
							{employeeDetail?.allowAdHock ? 'Ad-hoc Allowed ✓' : 'No Ad-hoc'}
						</Tag>
					</Space>
				</Row>
			</Card>

			<Divider />

			{/* System Information */}
			<Card title="System Information" size="small">
				<Descriptions column={1} size="small">
					<Descriptions.Item label="Application Name">
						<Typography.Text strong>{pac?.applicationName}</Typography.Text>
					</Descriptions.Item>
					<Descriptions.Item label="Version">
						<Tag color="geekblue">{pac?.version}</Tag>
					</Descriptions.Item>
					<Descriptions.Item label="Release Date">
						<Typography.Text>{dateTimeStamp}</Typography.Text>
					</Descriptions.Item>
				</Descriptions>
			</Card>
		</Modal>
	)
}
